export default "__VITE_ASSET__BzvNAdRf__"